// TODO: Add description for each angular config/controller/directive/module/service
export default function ($anchorScrollProvider) {
    'ngInject';
    $anchorScrollProvider.disableAutoScrolling();
}



// WEBPACK FOOTER //
// ./src/js/config/anchorScrollProvider.js